import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum } from '@shared/utils';
import { CardsApi, type ChangePinCardResponse } from '@shared/api';

interface ChangePinType {
  loading: boolean;
  error: string | null;
  success: boolean;
  change: (request: ChangePinCardResponse, id: string, signal?: AbortSignal) => Promise<void>;
  resetError: () => void;
  clear: () => void;
}

export const useChangePinStore = create<ChangePinType>((set) => ({
  loading: false,
  error: null,
  success: false,

  change: ApiUtils.wrapperApi(async (request, id, signal) => {
    try {
      set({ loading: true, error: null, success: false });
      await CardsApi.changePinCard(request, id, signal);
      set({ success: true, loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false, success: false });
    }
  }, RequestStrategyEnum.Debounce),

  resetError: () => set({ error: null }),

  clear: () => set({ loading: false, error: null, success: false }),
}));
